/*
 * Keep Dawn's native media-gallery behavior, but force the JECA2300 template
 * to present a single active hero media while thumbnails remain the only way
 * to switch between assets.
 */
(function () {
  const SELECTORS = {
    gallery: '.jeca2300-product-page media-gallery',
    viewerItems: '[id^="Slider-Gallery-"] > [data-media-id]',
    thumbItems: '[id^="Slider-Thumbnails-"] [data-target]',
  };

  function getViewerItems(gallery) {
    return Array.from(gallery.querySelectorAll(SELECTORS.viewerItems));
  }

  function getThumbItems(gallery) {
    return Array.from(gallery.querySelectorAll(SELECTORS.thumbItems));
  }

  function syncGalleryState(gallery) {
    const viewerItems = getViewerItems(gallery);
    if (!viewerItems.length) return;

    const activeItem = viewerItems.find((item) => item.classList.contains('is-active')) || viewerItems[0];
    const activeId = activeItem.dataset.mediaId;

    viewerItems.forEach((item) => {
      const isActive = item.dataset.mediaId === activeId;
      item.classList.toggle('is-active', isActive);
      item.hidden = !isActive;
      item.setAttribute('aria-hidden', String(!isActive));
    });

    getThumbItems(gallery).forEach((thumb) => {
      const button = thumb.querySelector('button');
      if (!button) return;

      const isCurrent = thumb.dataset.target === activeId;
      if (isCurrent) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  function enhanceGallery(gallery) {
    if (!gallery || gallery.dataset.jeca2300Ready === 'true') return;

    gallery.dataset.jeca2300Ready = 'true';
    syncGalleryState(gallery);

    const thumbItems = getThumbItems(gallery);
    thumbItems.forEach((thumb) => {
      const button = thumb.querySelector('button');
      if (!button) return;

      button.addEventListener('click', () => {
        window.requestAnimationFrame(() => syncGalleryState(gallery));
      });
    });

    gallery.addEventListener('keyup', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      window.requestAnimationFrame(() => syncGalleryState(gallery));
    });

    const observer = new MutationObserver((mutations) => {
      const classChanged = mutations.some(
        (mutation) => mutation.type === 'attributes' && mutation.attributeName === 'class'
      );
      if (classChanged) syncGalleryState(gallery);
    });

    getViewerItems(gallery).forEach((item) => {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function initJeca2300Gallery() {
    document.querySelectorAll(SELECTORS.gallery).forEach(enhanceGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJeca2300Gallery, { once: true });
  } else {
    initJeca2300Gallery();
  }

  document.addEventListener('shopify:section:load', initJeca2300Gallery);
})();
